import { render } from "./InvoiceInfo.vue?vue&type=template&id=cf90ead8&scoped=true"
import script from "./InvoiceInfo.vue?vue&type=script&lang=js"
export * from "./InvoiceInfo.vue?vue&type=script&lang=js"

import "./InvoiceInfo.vue?vue&type=style&index=0&id=cf90ead8&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-cf90ead8"

export default script